<section class="form">
  <header class="form__section form__section_header">
    <app-form-header
      title="{{'Payment' | translate}}"
    ></app-form-header>
  </header>
  <form class="form__section form__section_content"
    [formGroup]="formGroup"
  >
    <div class="accordeon">
      <div class="accordeon__header">
        <div
          class="accordeon-header"
          (click)="typeFormControl.setValue(
            typeFormControl.value === EFormPaymentType.card
              ? null
              : EFormPaymentType.card
          )"
        >
          <div
            class="accordeon-header__tick"
            [ngClass]="{
              'accordeon-header__tick_active': typeFormControl.value === EFormPaymentType.card
            }"
          ></div>
          <div class="accordeon-header__label">クレジットカード</div>
          <img
            class="accordeon-header__icons"
            [src]="(isLtSm | async)
              ? '/assets/images/cart-payments-mobile.png'
              : '/assets/images/cart-payments.png'"
          >
        </div>
      </div>
      <div
        *ngIf="typeFormControl.value === EFormPaymentType.card"
        class="accordeon__content"
        [@slideY]
      >
        <div class="section">
          <!-- Card Number -->
          <div class="section__input">
            <div class="input-wrap input-wrap_column">
              <div class="input-wrap__label">
                <div class="label">
                  <app-label class="label__item">上の枠には、カード番号・有効期限・CVC（カードに記載の3桁もしくは4桁のセキュリティコード）を入力し、下の枠にはカード名義をアルファベットで入力してください。</app-label>
                </div>
              </div>
              <div class="input-wrap__label">
                <div class="label">
                  <app-label 
                    class="label__item"
                    [forId]="inputCard.id"
                  >クレジットカード番号</app-label>
                  <div class="label__item">
                    <svg-icon
                      class="ssl-icon"
                      src="/assets/images/icons/order-main-payment-ssl.svg"
                      (mouseenter)="tooltipCartNumber.show()"
                      (mouseleave)="tooltipCartNumber.hide()"
                    ></svg-icon>
                    <app-tooltip #tooltipCartNumber>
                      {{'We use SSL for transaction and we dont store any credit card info.' | translate}}
                    </app-tooltip>
                  </div>
                </div>
              </div>
              <!-- <div class="input-wrap__input">
                <app-stripe-card #stripeCard></app-stripe-card>
                {{ stripeCard.error }}
                <div (click)="onCardTestClick()">Test</div>
              </div> -->
              <div class="input-wrap__input">
                <div class="input">
                  <div class="input__item">
                    <app-input #inputCard
                      type="stripe-card"
                      name="card"
                      formControlName="card"
                      [error]="inputCard.stripeCardComponent?.error"
                    ></app-input>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Name -->
          <div class="section__input">
            <div class="input-wrap input-wrap_column">
              <div class="input-wrap__label">
                <div class="label">
                  <app-label
                    class="label__item"
                    [forId]="inputName.id"
                  >カード名義（アルファベット）</app-label>
                </div>
              </div>
              <div class="input-wrap__input">
                <div class="input">
                  <div class="input__item">
                    <app-input #inputName
                      type="text"
                      name="name"
                      formControlName="name"
                    ></app-input>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="section__input section__input_buttons">
            <div class="buttons">
              <div class="buttons__item">
                <app-input
                  class="checkbox"
                  type="checkbox"
                  formControlName="terms"
                  error="チェックしてください"
                >
                  <a
                    class="checkbox__item"
                    routerLink="/terms"
                    target="_blank"
                  >利用規約</a>
                  <span class="checkbox__item">に同意します</span>
                </app-input>
              </div>
              <div class="buttons__item buttons__item_button">
                <app-button
                  [disabled]="submitButtonDisabled"
                  (buttonClick)="submitButtonClick.emit()"
                  [fullWidth]="(isLtMd | async)"
                >お支払いを完了する</app-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="accordeon__header">
        <div
          class="accordeon-header"
          (click)="typeFormControl.setValue(
            typeFormControl.value === EFormPaymentType.konbini
              ? null
              : EFormPaymentType.konbini
          )"
        >
          <div
            class="accordeon-header__tick"
            [ngClass]="{
              'accordeon-header__tick_active': typeFormControl.value === EFormPaymentType.konbini
            }"
          ></div>
          <div class="accordeon-header__label">コンビニ払い</div>
          <img
            class="accordeon-header__icons"
            [src]="(isLtSm | async)
            ? '/assets/images/konbini-payments-mobile.png'
            : '/assets/images/konbini-payments.png'"
          >
        </div>
      </div>
      <div
        *ngIf="typeFormControl.value === EFormPaymentType.konbini"
        class="accordeon__content accordeon__content_konbini"
        [@slideY]
      >
        <div class="konbini">
          <!-- ITEMS -->
          <ng-container *ngIf="isGift; then giftKonbiniItems; else defaultKonbiniItems"></ng-container>
          <ng-template #defaultKonbiniItems>
            <app-konbini-item class="konbini__section">コンビニでのお支払いをもって、ご注文完了となります。</app-konbini-item>
            <app-konbini-item class="konbini__section">{{ shippingDate | async }} に発送するには、<span class="red">お支払いの有効期限とは別に、</span>{{ endOfCycleDate | async }} 23:30までにご案内する手順に沿って各種コンビニ窓口でお支払いを完了いただく必要があります。<br>それを過ぎると、発送は{{ nextShippingDate | async }}となります。</app-konbini-item>
            <app-konbini-item class="konbini__section">返金はできません。</app-konbini-item>
          </ng-template>
          <ng-template #giftKonbiniItems>
            <app-konbini-item class="konbini__section">コンビニでのお支払いをもって、ご注文完了となります。</app-konbini-item>
            <app-konbini-item class="konbini__section">48時間以内にコンビニでお支払いをお願いします。</app-konbini-item>
            <app-konbini-item class="konbini__section">ギフトコードはお支払い完了後に、メールでお送りします。</app-konbini-item>
          </ng-template>
          <!-- BUTTONS -->
          <div class="konbini__section konbini__section_buttons">
            <div class="buttons">
              <div class="buttons__item">
                <app-input
                  class="checkbox"
                  type="checkbox"
                  formControlName="terms"
                  error="チェックしてください"
                >
                  <a
                    class="checkbox__item"
                    routerLink="/terms"
                    target="_blank"
                  >利用規約</a>
                  <span class="checkbox__item">に同意します</span>
                </app-input>
              </div>
              <div class="buttons__item buttons__item_button">
                <app-button
                  [disabled]="submitButtonDisabled"
                  (buttonClick)="submitButtonClick.emit()"
                  [fullWidth]="(isLtMd | async)"
                >コンビニで支払う<br *ngIf="!(isLtMd | async)"><small>（手順を確認する）</small></app-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</section>
